<simple-notifications [options]="{timeout: 3000}"></simple-notifications>
<div class="container-fluid">

  <mat-card class="col-md-4 col-md-offset-4 form-signin">

    <form [formGroup]="registerForm" (submit)="register()">
      <mat-card-title>Registrieren</mat-card-title>

      <app-server-errors [errors]="errors"></app-server-errors>

      <mat-form-field validationInput>
        <input matInput class="full-width" placeholder="E-Mail" type="text" formControlName="email" />
      </mat-form-field>

      <mat-form-field validationInput>
        <input matInput class="full-width" placeholder="Passwort" type="password" formControlName="password" />
      </mat-form-field>

      <mat-form-field validationInput>
        <input matInput class="full-width" placeholder="Passwort wiederholen" type="password" formControlName="repeatPassword" />
      </mat-form-field>

      <div formGroupName="address">
        <mat-form-field class="full-width" validationInput>
          <input matInput placeholder="Straße" type="text" class="full-width" formControlName="street" />
        </mat-form-field>

        <mat-form-field valivalidationInputdationInput>
          <input matInput placeholder="PLZ" type="text" formControlName="zip" />
        </mat-form-field>

        <mat-form-field validationInput>
          <input matInput placeholder="Stadt" type="text" formControlName="city" />
        </mat-form-field>
      </div>

      <footer class="row">
        <div class="col-sm-4">
          <button mat-raised-button type="submit" class="btn-block" color="primary">Account erstellen</button>
        </div>
        <div class="col-sm-4">
          <mat-progress-spinner *ngIf="isLoading" mode="indeterminate"></mat-progress-spinner>
        </div>
      </footer>
    </form>
  </mat-card>


</div> <!-- /container -->



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/register/register.component.html